import SECTORS from "./sectors";

export default value => {
    const data = SECTORS.find((i) => i.value === value);

    return data ? data.text : "N/A";
}
